export default __webpack_public_path__ + "static/tabVector-6bf8dfccb0253168121c5e9c0c436a95.svg";